import { render, staticRenderFns } from "./DashboardTopMenu.vue?vue&type=template&id=7c6cc752&scoped=true&"
import script from "./DashboardTopMenu.vue?vue&type=script&lang=js&"
export * from "./DashboardTopMenu.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTopMenu.vue?vue&type=style&index=0&id=7c6cc752&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6cc752",
  null
  
)

export default component.exports